import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4617d774"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4617d774')) {
      api.createRecord('4617d774', component.options)
    } else {
      api.reload('4617d774', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4617d774", function () {
      api.rerender('4617d774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/loop/index.vue"
export default component.exports